import { aed, num } from "@/lib/format";
import { displayItemName } from "@/lib/menuLocale";
import {
  buildReportDocument,
  openReportPrint,
  periodMeta,
  resolveReportLetterhead,
} from "@/lib/reportPrintShell";

function cell(value) {
  return value != null && value !== "" ? aed(value) : "";
}

export async function printBacklogReport(report, type, options = {}) {
  if (!report) return false;
  const withBranch = { ...report, branch_id: report.branch_id ?? options.branchId, all_branches: options.allBranches };

  let title = "Report";
  let headers = "";
  let rows = "";

  switch (type) {
    case "categories":
      title = "Category Wise Sales";
      headers = "<tr><th>Category</th><th>Qty</th><th>Net</th></tr>";
      rows = (withBranch.rows || [])
        .map((r) => `<tr><td>${r.category_name}</td><td class="num">${num(r.qty)}</td><td class="num">${cell(r.net_sales)}</td></tr>`)
        .join("");
      break;
    case "top-items":
      title = "Top Selling Items";
      headers = "<tr><th>#</th><th>Item</th><th>Qty</th><th>Net</th></tr>";
      rows = (withBranch.rows || [])
        .map((r) => `<tr><td>${r.rank}</td><td>${displayItemName(r)}</td><td class="num">${num(r.qty)}</td><td class="num">${cell(r.net_sales)}</td></tr>`)
        .join("");
      break;
    case "suppliers":
      title = "Supplier Summary";
      headers = "<tr><th>Supplier</th><th>Purchases</th><th>Payments</th><th>Balance</th><th>Limit</th></tr>";
      rows = (withBranch.rows || [])
        .map((r) => `<tr><td>${r.supplier_name}</td><td class="num">${cell(r.purchase_amount)}</td><td class="num">${cell(r.payment_amount)}</td><td class="num">${cell(r.balance)}</td><td class="num">${cell(r.credit_limit)}</td></tr>`)
        .join("");
      break;
    case "kitchen":
      title = "Kitchen Report";
      headers = "<tr><th>Station</th><th>Tickets</th><th>Served</th></tr>";
      rows = (withBranch.by_station || [])
        .map((r) => `<tr><td>${r.station}</td><td class="num">${r.ticket_count}</td><td class="num">${r.served_count}</td></tr>`)
        .join("");
      break;
    case "orders":
      title = "Order Summary";
      headers = "<tr><th>Status</th><th>Orders</th><th>Amount</th></tr>";
      rows = (withBranch.by_status || [])
        .map((r) => `<tr><td>${r.status}</td><td class="num">${r.order_count}</td><td class="num">${cell(r.net_amount)}</td></tr>`)
        .join("");
      break;
    default:
      return false;
  }

  const company = await resolveReportLetterhead({ branchId: withBranch.branch_id, allBranches: withBranch.all_branches });
  const html = buildReportDocument({
    title,
    company,
    metaHtml: periodMeta(withBranch),
    bodyHtml: `<table><thead>${headers}</thead><tbody>${rows}</tbody></table>`,
  });
  return openReportPrint(html);
}
